import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';


export default class GlobalizationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return (params.interpolateParams as any)?.fallback ?? `[[[${params.key}]]]`;
  }
}
